import { useCallback, useMemo } from 'react';
import { emailUsernameFromOrg } from '~/common/stably-email/email-username-from-org';
import { env } from '~/env.mjs';
import { useAuthData } from '~/hooks/auth/use-auth-data';

// Email prefix (based on org name) and domain are fixed for all inboxes
export const useGetInboxAddress = () => {
  const { activeOrg } = useAuthData();
  const emailPrefix = useMemo(() => emailUsernameFromOrg(activeOrg?.orgName || ''), [activeOrg?.orgName]);

  const getInboxAddressStatic = useCallback(
    (usernameSuffix: string) => `${emailPrefix}+${usernameSuffix}@${env.NEXT_PUBLIC_STABLY_EMAIL_DOMAIN}`,
    [emailPrefix],
  );
  const getInboxAddressDynamic = useCallback(
    (usernameSuffix: string) => `\`${emailPrefix}+\${${usernameSuffix}}@${env.NEXT_PUBLIC_STABLY_EMAIL_DOMAIN}\``,
    [emailPrefix],
  );

  return { getInboxAddressStatic, getInboxAddressDynamic };
};
